// extracted by mini-css-extract-plugin
export default {"component-microsite-menu":"MicrositeMenu-style-module_component-microsite-menu_sKOOs","componentMicrositeMenu":"MicrositeMenu-style-module_component-microsite-menu_sKOOs"};